export default {
  namespaced: true,
  state: {
    mayUseCookie: false,
  },
  mutations: {
    allowCookieUsage(state) {
      state.mayUseCookie = true;
    },
  },
};
